import React from "react"
import {Route, Routes} from "react-router-dom"

import {Duplicate} from "./Duplicate"
import {New} from "./New"
import {View} from "./View"

export const SMSTemplate = () => (
	<Routes>
		<Route path="/:id/duplicate" element={<Duplicate />} />
		<Route path="/new" element={<New />} />
		<Route path="/:id" element={<View />} />
	</Routes>
)
